import { metricKeys } from '@pulse/metrics';
import { ALL_TRAFFIC } from '@utils/filter';
import { getValidPresetKeys } from '@src/utils/presets/utils';

const PRESET_KEYS = getValidPresetKeys();

export const genAIUsecases = ({ validateMetric, validateDimension }) => ({
  [PRESET_KEYS.AD_REACH]: {
    title: 'Ad Reach & Frequency',
    key: PRESET_KEYS.AD_REACH,
    hide: false,
    description:
      'Track Ad Frequency and Reach. Understand Ad Load and how for many Ad Impressions the Ad is watched completely. Track Ad Slates.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.Plays),
        metrics: validateMetric([
          metricKeys.Plays,
          metricKeys.AdUniqueDevices,
          metricKeys.AdTotalMinutes,
          metricKeys.EndedPlaysPerUniqueDevice,
          metricKeys.AdCompletedCreativePlays,
          metricKeys.AdSlateDurationPct,
          metricKeys.AdSlatePlaysPct,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'OBJECT_NAME',
            'm3.dv.n',
            'c3.video.isLive',
            'GEO_COUNTRY',
          ]),
        },
      },
    },
  },
  [PRESET_KEYS.AD_PERFORMANCE]: {
    title: 'Ad Performance',
    key: PRESET_KEYS.AD_PERFORMANCE,
    hide: false,
    description: 'Analyze Ad Performance and User Experience.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.Plays),
        metrics: validateMetric([
          metricKeys.Plays,
          metricKeys.AdCompletedCreativePlays,
          metricKeys.Bitrate,
          metricKeys.VideoStartFailures,
          metricKeys.VideoPlaybackFailures,
          metricKeys.RebufferingRatio,
          metricKeys.VideoStartTime,
          metricKeys.ExitBeforeVideoStarts,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'OBJECT_NAME',
            'm3.dv.n',
            'c3.ad.position',
            'c3.ad.technology',
          ]),
        },
      },
    },
  },
});
